'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationSignupSimpleMediatorCtrl', function ($scope, $uibModalInstance, $rootScope, regexStrings,
                                                          $state, OrganizationSettings, Session, $timeout,
                                                          Angularytics, InternalAnalyticsService) {

      $scope.access_token = Session.getAccessToken();
      $scope.modalInstance = $uibModalInstance;

      $scope.regexStrings = regexStrings;

      $scope.state = {
        panels: {
          enterName: true,
          enterStore: false,
          summary: false
        },
        formData: {
          firstName: null,
          lastName: null,
          storeName: null,
          phone: null
        }
      };

      $scope.submitName = function() {
        $scope.state.panels.enterName = false;
        $scope.state.panels.enterStore = true;

        $('.mini_modal_signup .enter-store-panel #StoreName').focus();

        Session.getMe()
          .then(function(me) {
            me.$update({
              first_name: $scope.state.formData.firstName,
              last_name: $scope.state.formData.lastName
            })
              .then(function() {

              }, function() {

              });
          }, function() {

          });
      };

      $scope.submitStore = function() {

        if ($scope.state.formData.phone) {
          var orgSettings = {
            organization_id: Session.getCurrentOrgId()
          };
          orgSettings.phone_number = $scope.state.formData.phone;

          OrganizationSettings.create(orgSettings)
            .then(function() {

            }, function() {

            });
        }

        Session.getCurrentOrg()
          .then(function(org) {
            org.$update({
                name: $scope.state.formData.storeName,
                setup_mailchimp_subscriptions: true
              })
              .then(function() {
                $scope.wizardComplete();

              }, function() {

              });
          }, function() {

          });

        // $scope.state.panels.enterStore = false;
        // $scope.state.panels.summary = true;
      };

      $scope.submitSummary = function() {
        $scope.wizardComplete();
        // InternalAnalyticsService.captureAnalytic('signupWizard:registrationComplete', {
        //   first_name: $scope.sections.account.formData.firstName,
        //   last_name: $scope.sections.account.formData.lastName,
        //   email: $scope.sections.account.formData.email,
        //   company_name: newUser.memberships[0].organization.name,
        //   organization_id: newUser.memberships[0].organization.id
        // });
      };

      $scope.close = function() {
        $uibModalInstance.close('close')
      }

      $scope.wizardComplete = function() {
        Session.getCurrentOrg(true)
          .then(function(org) {
            var d = new Date(org.demo_metadata.work_period_start_date)
            d.setDate(d.getDate() + 5)
            $state.go('daysOff.intermediate.date.pending', { date: moment(d).format('YYYY-MM-01') } )

            $timeout(function() {
              $uibModalInstance.close('finished wizard')
              $rootScope.$broadcast('forceDemoStart')
            }, 500)
          }, function() {})
      }
    })
